import React, { useState, useEffect, useCallback } from "react";
import { Grid, Typography, Box } from "@mui/material";
import { AutoCompleteComponent, ModalError } from "components";
import { getErrors } from "utils";
import { listDspDownloadOptions } from "utils/DSPSFTPService";
import SFTPExplorer from "./SFTPExplorer";
import GlusterExplorer from "./GlusterExplorer";
import DSPSFTPConfigDialog from "./DSPSFTPConfigDialog";

function ComponentReportProcessDownload() {
  const [selectedDspId, setSelectedDspId] = useState("");
  const [dspOptions, setDspOptions] = useState([]);
  const [isLoadingDsp, setIsLoadingDsp] = useState(false);
  const [configDialogOpen, setConfigDialogOpen] = useState(false);
  // Bump this counter to tell GlusterExplorer to refresh after a download
  const [glusterRefreshTick, setGlusterRefreshTick] = useState(0);

  // ─── Load active DSP SFTP configs ──────────────────────────────────────────
  const fetchDspOptions = useCallback(async () => {
    setIsLoadingDsp(true);
    try {
      const res = await listDspDownloadOptions(1, 100, "");
      const raw = res?.data?.data?.data || res?.data?.data || [];
      setDspOptions(
        raw.map(item => ({
          id: item.id || item.config_id,
          label: item.dsp_config_name,
          slug: item.slug || item.dsp_slug || "",
        }))
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setIsLoadingDsp(false);
    }
  }, []);

  useEffect(() => {
    fetchDspOptions();
  }, [fetchDspOptions]);

  const handleDownloadStarted = () => {
    setGlusterRefreshTick(t => t + 1);
  };

  const selectedDsp = dspOptions.find(opt => opt.id === selectedDspId) || null;

  return (
    <Box>
      {/* DSP selector row */}
      <Grid container columnSpacing={2} alignItems="center" mb="16px">
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <AutoCompleteComponent
            label="DSP"
            options={dspOptions}
            value={selectedDsp}
            onChange={(value, e) => {
              console.log({ e: e.target.value });
              setSelectedDspId(value || "");
              console.log(value, e || "");
            }}
            loading={isLoadingDsp}
            size="small"
            width="100%"
          />
        </Grid>
      </Grid>

      {/* Empty state */}
      {!selectedDsp ? (
        <Box textAlign="center" mt={8}>
          <Typography color="textSecondary">
            Select a DSP to browse and download DSRF files.
          </Typography>
        </Box>
      ) : (
        <Grid container columnSpacing={4} mt={2}>
          <Grid item xs={12} md={6}>
            <SFTPExplorer
              dsp={selectedDsp}
              onDownloadStarted={handleDownloadStarted}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <GlusterExplorer
              dsp={selectedDsp}
              refreshTrigger={glusterRefreshTick}
            />
          </Grid>
        </Grid>
      )}

      {/* DSP SFTP config management dialog */}
      <DSPSFTPConfigDialog
        open={configDialogOpen}
        onClose={() => setConfigDialogOpen(false)}
        onSaved={() => {
          setConfigDialogOpen(false);
          fetchDspOptions();
        }}
      />
    </Box>
  );
}

export default ComponentReportProcessDownload;
